// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRECIO_JUSTO_ACT_CLEAR_BATCH_COUNT,
} from './constants';

export function actClearBatchCount() {
  return {
    type: PRECIO_JUSTO_ACT_CLEAR_BATCH_COUNT,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRECIO_JUSTO_ACT_CLEAR_BATCH_COUNT:
      return {
        ...state,
        actBatchCountPending: false,
        actBatchCountError: null,
        batchCount: {count: 0}
      };

    default:
      return state;
  }
}
